<div class="kz-explore-filters">
  <kz-filter-item class="kz-explore-filters--type">
    <kz-checkbox-toggle>
      <input class="kz-checkbox" #checkbox
             type="checkbox"
             [checked]="switch === 'members'" (click)="changeSwitch()"
             id="kz-explore-filters--type"
             name="kz-explore-filters--type"/>
      <span labelLeft i18n="@@kazacafe.explore.menu.slider">Posts</span>
      <span labelRight i18n="@@kazacafe.explore.menu.sliderB" >Members</span>
    </kz-checkbox-toggle>
  </kz-filter-item>
  <button type="button" kzButton buttonStyle="flat" class="kz-explore-filters--button" (click)="openPopin()"><span><kz-icons name="filters"></kz-icons>
    <ng-container *ngIf="(fluxOptionsService.activeFiltersObs | async) as activeFilters">
      <span *ngIf="activeFilters.length > 0" i18n="@@kazacafe.explore.menu.activeFilters">Active filters ({{ activeFilters.length }})</span> <span *ngIf="activeFilters.length === 0" i18n="@@kazacafe.explore.menu.filter">Filter</span>
    </ng-container></span></button>

  <ng-container *ngIf="(fluxOptionsService.activeFiltersObs | async) as activeFilters">
    <ul class="kz-explore-filters--list" *ngIf="activeFilters.length > 0">
      <li *ngFor="let filter of activeFilters" class="filter-list"><span>{{ filter.category?.name }} :</span> {{ filter.value }} <button class="kz-explore-filters--remove" title="Supprimer le filtre" (click)="removeFilter(filter)"><kz-icons name="cross"></kz-icons></button></li>
      <li *ngIf="activeFilters.length > 1" class="kz-explore-filters--list-clean"><button class="kz-explore-filters--remove" title="Supprimer tous les filtres" (click)="removeAllFilters()"><kz-icons name="cross"></kz-icons></button></li>
    </ul>
  </ng-container>
</div>
